var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 33C26.8366 33 34 25.8366 34 17C34 8.16344 26.8366 1 18 1C9.16344 1 2 8.16344 2 17C2 25.8366 9.16344 33 18 33Z",
    fill: "#637282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 17C33 25.2843 26.2843 32 18 32C9.71573 32 3 25.2843 3 17C3 8.71573 9.71573 2 18 2C26.2843 2 33 8.71573 33 17Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5591 23H18.8633C21.4199 23 23.0054 21.6885 23.0054 19.5884V19.5718C23.0054 18.0029 21.8018 16.8242 20.1333 16.6997V16.6499C21.4531 16.4756 22.4492 15.355 22.4492 14.0435V14.0269C22.4492 12.1841 21.0298 11.022 18.772 11.022H13.5591V23ZM18.1245 12.8813C19.2949 12.8813 19.9839 13.4292 19.9839 14.3838V14.4004C19.9839 15.438 19.2285 16.0273 17.8174 16.0273H16.0659V12.8813H18.1245ZM18.1162 17.729C19.6519 17.729 20.4487 18.3184 20.4487 19.4141V19.4307C20.4487 20.543 19.6602 21.1323 18.2241 21.1323H16.0659V17.729H18.1162Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.239216 0 0 0 0 0.647059 0 0 0 0 0.329412 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.239216 0 0 0 0 0.647059 0 0 0 0 0.329412 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndPoint);
export default __webpack_public_path__ + "static/media/4bd963395704baf1ce141da5a169e2a0e1b90f90fa.svg";
export { ForwardRef as ReactComponent };